import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { theme } from 'utils/style/theme';

/**
 *
 * @param {*} param0
 * @returns {UTC timer}
 */

const UtcTimer = ({ onGrayBox, startDate, endDate, style }) => {
  return (
    <>
      {onGrayBox === true ? (
        <UnderCalender style={style}>
          <div className='wrap' style={style}>
            <div className='start'>
              UTC:
              <p>
                {startDate &&
                  endDate &&
                  dayjs(startDate).add(-9, 'hours').format('YYYY-MM-DD HH:mm')}
              </p>
              ~
              <p>
                {startDate &&
                  endDate &&
                  dayjs(endDate).add(-9, 'hours').format('YYYY-MM-DD HH:mm')}
              </p>
            </div>
          </div>
        </UnderCalender>
      ) : (
        <>
          <p />
          <div
            style={{ fontSize: '0.85rem', color: 'gray', marginTop: '0.2rem' }}
          >
            UTC:
            {dayjs(startDate ? startDate : endDate)
              .add(-9, 'hours')
              .format('YYYY-MM-DD HH:mm')}
          </div>
        </>
      )}
    </>
  );
};

export default UtcTimer;
const UnderCalender = styled.div`
  .wrap {
    /* border: solid 2px red; */
    margin-left: 0.5rem;
    height: 100%;
    display: flex;
    align-items: center;
    div,
    span {
      color: ${theme.colors.gray_2};
    }
    .start {
      display: flex;
      p {
        margin: 0 0.5rem;
      }
    }
  }
`;
